// client/src/components/contratos/ContratoRow.js
import React from 'react';
import { MoreVertical } from 'lucide-react';

// Contraparte pode ser Cliente/Fornecedor/Transportador (Contrato.modeloContraparte,
// refPath polimórfico) — só Cliente tem subdocumento .user.
const getContraparteNome = (contrato) => {
    const c = contrato?.cliente;
    if (!c || typeof c !== 'object') return 'Contraparte não encontrada';
    if (contrato.modeloContraparte === 'Fornecedor') return c.nomeFantasia || c.razaoSocial || 'Contraparte não encontrada';
    if (contrato.modeloContraparte === 'Transportador') return c.nomeCompleto || c.razaoSocial || c.nomeFantasia || 'Contraparte não encontrada';
    return c.user?.name || c.nome || 'Contraparte não encontrada';
};

// Enum real: Contrato.statusContrato em server/models/Contrato.js
const getStatusClass = (status) => {
    switch (status) {
        case 'Ativo': return 'badge-green';
        case 'Em Elaboração': return 'badge-yellow';
        case 'Finalizado': return 'badge-gray';
        case 'Cancelado': return 'badge-red';
        default: return 'badge-blue';
    }
};

const ContratoRow = ({ contrato, onOpenActions }) => {
    return (
        <tr className="table-row-hover">
            <td className="td-name">{contrato.numeroContrato}</td>
            <td>{getContraparteNome(contrato)}</td>
            <td>{contrato.tipoContrato?.nome || 'N/A'}</td>
            <td>
                <span className={`badge ${getStatusClass(contrato.statusContrato)}`}>
                    {contrato.statusContrato}
                </span>
            </td>
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={() => onOpenActions(contrato)}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default ContratoRow;
